import { NbCalendarRange } from '@nebular/theme';
import { DateInput, DateInputConstructor } from './date-input';

export type DateRangeInputConstructor = DateInputConstructor<NbCalendarRange<Date>>

export class DateRangeInput extends DateInput<NbCalendarRange<Date>> {
  inputType = 'date-range';

  constructor(options: Partial<DateRangeInputConstructor>) {
    super(options);
  }
}
